const ITEMS = [
    "Specialist Motorhome Valeting",
    "Ceramic Coatings",
    "Over 20 Years Experience",
    "Any Valet Tailored To Suit",
];

export const Marquee = () => {
    const strip = [...ITEMS, ...ITEMS];
    return (
        <div className="relative border-y border-indigo-400/25 bg-indigo-950 py-6 overflow-hidden" data-testid="editorial-marquee">
            <div className="pv-marquee-track">
                {[0, 1].map((half) => (
                    <div key={half} className="flex shrink-0">
                        {strip.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center shrink-0">
                                <span className="font-serif-display italic text-xl sm:text-2xl text-white px-8 whitespace-nowrap">{item}</span>
                                <span className="text-blue-300/60 text-xs">✦</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
